export class NotificationFilter {
  isRead?: boolean;
  managerId?: number;
}
